import { render, staticRenderFns } from "./DriverDetailView.vue?vue&type=template&id=c881e9de&scoped=true"
import script from "./DriverDetailView.vue?vue&type=script&lang=js"
export * from "./DriverDetailView.vue?vue&type=script&lang=js"
import style0 from "./DriverDetailView.vue?vue&type=style&index=0&id=c881e9de&prod&scoped=true&lang=css"
import style1 from "./DriverDetailView.vue?vue&type=style&index=1&id=c881e9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c881e9de",
  null
  
)

export default component.exports